import { saveAs } from 'file-saver'

const downloadFile = (data, filename) => {
  const blob = data instanceof Blob ? data : new Blob([data])
  saveAs(blob, filename)
}

export default downloadFile
